import type { RouterOptions } from 'owa-router';
import { initializeMailRoutes, getCurrentRoute } from 'owa-mail-routing';

export const mailRouterOptions: RouterOptions = {
    routeGenerator: Promise.resolve(getCurrentRoute),
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function indexOf called at module scope is not allowed. This may cause unwanted side effects. */
    vdir: window?.location?.pathname.indexOf('/hosted/mail') == 0 ? 'hosted/mail' : 'mail',
    defaultRoute: '/',
    registerRoutes: initializeMailRoutes,
};
